import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import qs from 'query-string';
import trans from 'counterpart';
import { getBlock, postBlock } from '../../api/blockApi';
import SymfonyForm from '../form/SymfonyForm';

/**
 * NOTE:
 * This component is a complete hack to support the original way SEM works.
 * We hook into the form submit and manually trigger our own submit to allow submitting with Ajax instead of a page change.
 */
class BrochureRequestBlock extends React.Component {
  state = {
    form: null,
    form_error: false,
    request_error: false,
    request_sent: false,
  }

  componentDidMount = () => {
    const { location } = this.props;
    const params = qs.parse(location.search);

    getBlock(this.props.id, params)
      .then((response) => {
        this.setState({
          form: response.data.form,
        });
      })
      .catch(() => {
        this.setState({ form_error: true });
      });
  }

  handleSubmit = (values) => {
    postBlock(this.props.id, values)
      .then((response) => {
        this.setState({
          form: response.data.form,
          form_error: response.data.form_error,
          request_error: response.data.request_error,
          request_sent: response.data.request_sent
        });
      });
  }

  render = () => {
    const { form } = this.state;

    if (this.state.request_sent) {
      return (
        <div className="alert alert-success text-center">
          {trans('alert.brochure_request_successful')}
        </div>
      );
    }

    if (!form) return null;

    return (
      <div>
        <SymfonyForm
          name="brochure"
          formDefinition={form}
          onSubmit={this.handleSubmit}
        />
        {this.state.request_error === true && (
          <div className="alert alert-danger">
            {trans('alert.brochure_request_error')}
          </div>
        )}
        {this.state.form_error === true && (
          <div className="alert alert-danger">
            {trans('alert.brochure_form_error')}
          </div>
        )}
      </div>
    );
  }
}

BrochureRequestBlock.propTypes = {
  id: PropTypes.number,
  location: PropTypes.object,
};

export default withRouter(BrochureRequestBlock);
